import React from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";

function ETLMapping() {


  return (
    <>
      <CloneRepo />
    </>
  );
}

export default ETLMapping;